export enum TicketCategoryEnum {
  UI_BUG = 'UI BUG',
  BILLING_ISSUES = 'BILLING ISSUES',
  COMPLIANCE_QUESTION = 'COMPLIANCE QUESTION',
  FEATURE_REQUEST = 'FEATURE REQUEST',
  OTHER = 'OTHER',
}

export enum TicketSeverityEnum {
  LOW = 'LOW',
  MEDIUM = 'MEDIUM',
  HIGH = 'HIGH',
}

export enum TicketStatusEnum {
  OPEN = 'OPEN',
  IN_PROGRESS = 'IN_PROGRESS',
  RESOLVED = 'RESOLVED',
  CLOSED = 'CLOSED',
}

export enum TicketEvents {
  CREATED = 'ticket.created',
  CLOSED = 'ticket.closed',
  DELETED = 'ticket.deleted',
  ASSIGNED = 'ticket.assigned',
  UPDATED = 'ticket.updated',
  NOTE_ADDED = 'ticket.note_added',
}
